import { Form, FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import {BucketCompanyCode} from "../../../models/config/BucketCompanyCode";
import React, {forwardRef, useImperativeHandle, useState} from "react";
import {twMerge} from "tailwind-merge";

export type BucketCompanyCodeFormRefHandle = {
    submit: () => BucketCompanyCode | undefined;
};

export type BucketCompanyCodeFormProps = {
    disabledKeyField?: boolean;
    defaultValues?: BucketCompanyCode;
    className?: string;
};

export const BucketCompanyCodeForm = forwardRef<
    BucketCompanyCodeFormRefHandle,
    BucketCompanyCodeFormProps
>((props, ref) => {
    const { disabledKeyField, defaultValues, className } = props;

    const [formValues, setFormValues] = useState<
        Partial<BucketCompanyCode>
    >({ ...defaultValues });
    const [errors, setErrors] = useState<Record<keyof BucketCompanyCode, string>>(
        {} as BucketCompanyCode
    );

    const handleFormValueChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const key = event.currentTarget.name;
        const value = event.currentTarget.value;

        setFormValues({ ...formValues, [key]: value });
    };

    const submitForm = () => {
        const errors: [keyof BucketCompanyCode, string][] = [];
        if (!formValues.sid) {
            errors.push(['sid', 'กรุณากรอก SID']);
        }
        if (!formValues.company_code) {
            errors.push(['company_code', 'กรุณากรอก Company Code']);
        }
        if (!formValues.company_bucket_code) {
            errors.push(['company_bucket_code', 'กรุณากรอก Company Bucket Code']);
        }

        if (errors.length > 0) {
            setErrors(prevState => ({
                ...prevState,
                // @ts-ignore
                ...Object.fromEntries(errors)
            }));

            return undefined;
        }

        return {...formValues} as BucketCompanyCode;
    };

    useImperativeHandle(
        ref,
        () => ({
            submit: submitForm
        }),
        [submitForm]
    );
    
    return (
        <Form className={twMerge('tw-flex tw-flex-col', className)}>
            <FormGroup>
                <Label for="sid">SID</Label>
                <Input
                    disabled={disabledKeyField}
                    invalid={!!errors.sid}
                    id="sid"
                    type="text"
                    name="sid"
                    value={formValues.sid}
                    onChange={
                        !disabledKeyField ? handleFormValueChange : undefined
                    }
                />
                <FormFeedback>{errors.sid}</FormFeedback>
            </FormGroup>
            <FormGroup>
                <Label for="company_code">Company Code</Label>
                <Input
                    invalid={!!errors.company_code}
                    id="company_code"
                    type="text"
                    name="company_code"
                    value={formValues.company_code}
                    onChange={handleFormValueChange}
                />
                <FormFeedback>{errors.company_code}</FormFeedback>
            </FormGroup>
            <FormGroup>
                <Label for="company_bucket_code">Company Bucket Code</Label>
                <Input
                    invalid={!!errors.company_bucket_code}
                    id="company_bucket_code"
                    type="text"
                    name="company_bucket_code"
                    value={formValues.company_bucket_code}
                    onChange={handleFormValueChange}
                />
                <FormFeedback>{errors.company_bucket_code}</FormFeedback>
            </FormGroup>
        </Form>
    );
});

BucketCompanyCodeForm.displayName = 'BucketCompanyCodeForm';